import React from 'react';
import { observer } from 'mobx-react-lite';
import { Link, Typography } from '@mui/material';
import StringUtils from '../../utils/string';
import { DocumentViewer } from '../uiComponents/documentViewer';

export const DocumentViewerField: React.FC<{ title: string; url: string }> = observer(
    ({ title, url }) => {
        const [docViewerOpen, setDocViewerOpen] = React.useState<boolean>(false);

        const handleDocViewerOpen = () => {
            setDocViewerOpen(true);
        };

        const handleDocViewerClose = () => {
            setDocViewerOpen(false);
        };

        return (
            <>
                {title && url && (
                    <>
                        <Link onClick={handleDocViewerOpen} style={{ cursor: 'pointer' }}>
                            <Typography variant='body2'>
                                View {StringUtils.toTitleCase(title.replace('_', ' '))}
                            </Typography>
                        </Link>

                        <DocumentViewer
                            openDocViewer={docViewerOpen}
                            closeDocViewer={handleDocViewerClose}
                            doc={{ title: title, url: url }}
                        />
                    </>
                )}
            </>
        );
    },
);
